import { EMPTY_MOVEMENT_PATTERN_MODEL } from "presentation/model/MovementPattern/MovementPatternModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: MovementPatternProvider,
    useTracked: useMovementPatternTracked
} = createContainer(() => useState(EMPTY_MOVEMENT_PATTERN_MODEL), {concurrentMode: true});
export { MovementPatternProvider, useMovementPatternTracked };

